import moment from "moment";
import React from "react";
import { invertColor } from "../../../../../utils/annual-planner-helpers";

export const PhaseCheckbox = ({
  phase,
  phasesAttachments,
  handlePhaseSelection,
  weekFirstDay,
}) => {
  const dateAttachment = Number(moment(weekFirstDay).format("YYYYMMDD"));
  const weekLastDay = moment(weekFirstDay).add(6, "days");

  const phaseName = phase.phaseName;
  const isSelected =
    phasesAttachments &&
    phasesAttachments.find(
      (phase) =>
        moment(phase.dateAttachment, "YYYYMMDD").isBetween(
          moment(weekFirstDay),
          moment(weekLastDay),
          undefined,
          "[]"
        ) && phase.phaseName === phaseName
    );
  const imageTint = invertColor(phase.phaseColor, true);

  return (
    <div
      style={{
        backgroundColor: isSelected ? phase.phaseColor : "var(--white-10)",
      }}
      className={"phase-checkbox"}
      onClick={() =>
        handlePhaseSelection(
          phaseName,
          dateAttachment,
          weekFirstDay,
          isSelected
        )
      }
    >
      {isSelected && (
        <img
          src="/img/svg/check.svg"
          style={{ filter: imageTint, width: "10px", height: "10px" }}
        />
      )}
    </div>
  );
};
